import { create } from 'zustand';
import type {
  BenefitDesignInputs,
  CombinedFilterType,
  InflationType,
} from '@/features/shop-insurance';

interface BenefitDesignInputsState {
  inputs: BenefitDesignInputs;
  actions: {
    setMonthlyBenefit: (value: number | null) => void;
    setBenefitDuration: (value: CombinedFilterType | null) => void;
    setInflationProtection: (value: CombinedFilterType | null) => void;
    setInflationTypes: (value: InflationType[] | null) => void;
    reset: () => void;
  };
}

const DEFAULT_INPUTS: BenefitDesignInputs = {
  monthlyBenefit: null,
  benefitDuration: null,
  inflationProtection: null,
  inflationTypes: null,
};

export const useBenefitDesignInputsStore = create<BenefitDesignInputsState>(set => ({
  inputs: { ...DEFAULT_INPUTS },
  actions: {
    setMonthlyBenefit: value =>
      set(state => ({ inputs: { ...state.inputs, monthlyBenefit: value } })),
    setBenefitDuration: value =>
      set(state => ({ inputs: { ...state.inputs, benefitDuration: value } })),
    setInflationProtection: value =>
      set(state => ({ inputs: { ...state.inputs, inflationProtection: value } })),
    setInflationTypes: value =>
      set(state => ({ inputs: { ...state.inputs, inflationTypes: value } })),
    reset: () => set({ inputs: { ...DEFAULT_INPUTS } }),
  },
}));

export const useBenefitDesignInputs = () =>
  useBenefitDesignInputsStore(state => state.inputs);

export const useBenefitDesignInputsActions = () =>
  useBenefitDesignInputsStore(state => state.actions);
